import React, { useEffect, useMemo } from 'react'
import { ArticlesType } from '../../types/mainModulTypes'
import ZigZag from './ZigZag'
import PrimaryImage from './PrimaryImage'
import WorkshopGalleryBig from './WorkshopGalleryBig'
import WorkshopGallerySmall from './WorkshopGallerySmall'
import { useLocation } from 'react-router-dom'
import SecondaryCenteredText from './SecondaryCenteredText'
import SecondaryLeftTextRightImageButton from './SecondaryLeftTextRightImageButton'
import Quote from './Quote'
import BaseSubheadline from '../common/BaseSubheadline'
import dayjs from 'dayjs'

export default function Articles(props: ArticlesType) {

    const modulRegistry: { [key: string]: React.ComponentType<any> } = {
        primaryImage: PrimaryImage,
        workshopGalleryBig: WorkshopGalleryBig,
        workshopGallerySmall: WorkshopGallerySmall,
        secondaryCenteredText: SecondaryCenteredText,
        secondaryLeftTextRightImageButton: SecondaryLeftTextRightImageButton,
        quote: Quote,
        zigZag: ZigZag,
    }

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth" }); 
            }
        }
    }, [location]);

    const orderedArticles = useMemo(() => {
        return [...props.articlesProvider].sort((a, b) => new Date(b.authored as string).getTime() - new Date(a.authored as string).getTime())
    }, [props?.articlesProvider])

    
    return (
        <div>
            {orderedArticles.map((article, index) => (
                <div
                    key={index}
                    id={article.content?.routePath.replace('/', '')}
                    className={`${index % 2 === 0 ? 'bg-accent ' : 'bg-base-100'} py-16 rounded-default`}
                >
                    <div className='py-8'>
                        <BaseSubheadline label={dayjs(article.authored).format("DD.MM.YYYY")} classProps='text-center pb-8' />
                    </div>
                    {(article.content?.articleModuls ?? []).map((block, index) => {
                       
                        const ModulComponent = modulRegistry[block?.type]
                        if (!ModulComponent) {
                            return (
                                <div key={index}>
                                    Kein Modul für Typ: <strong>{block?.type}</strong>
                                </div>
                            )
                        }
                        return (
                            <div key={index} className='py-8 max-w-content mx-auto '>
                                <ModulComponent key={index} {...block} />
                            </div>
                        )
                    })}

                </div>

            ))}

        </div>
    )
}
